export interface Patient {
  id: string;
  name: string;
  age: number;
  gender: 'male' | 'female' | 'other';
  location: string;
  injury: string;
  painLevel: number;
}

export const mockPatients: Patient[] = [
  { id: '1', name: 'John Doe', age: 35, gender: 'male', location: 'New York', injury: 'Lower Back Pain', painLevel: 7 },
  { id: '2', name: 'Jane Smith', age: 28, gender: 'female', location: 'Los Angeles', injury: 'Neck Strain', painLevel: 5 },
  { id: '3', name: 'Bob Johnson', age: 45, gender: 'male', location: 'Chicago', injury: 'Sciatica', painLevel: 8 },
  { id: '4', name: 'Alice Brown', age: 52, gender: 'female', location: 'Houston', injury: 'Shoulder Pain', painLevel: 6 },
  { id: '5', name: 'Charlie Wilson', age: 30, gender: 'male', location: 'Phoenix', injury: 'Knee Pain', painLevel: 4 },
  { id: '6', name: 'Eva Garcia', age: 40, gender: 'female', location: 'Miami', injury: 'Carpal Tunnel', painLevel: 3 },
  { id: '7', name: 'David Lee', age: 55, gender: 'male', location: 'Seattle', injury: 'Hip Pain', painLevel: 7 },
  { id: '8', name: 'Grace Taylor', age: 33, gender: 'female', location: 'Boston', injury: 'Plantar Fasciitis', painLevel: 5 },
  { id: '9', name: 'Frank Miller', age: 48, gender: 'male', location: 'Denver', injury: 'Tennis Elbow', painLevel: 6 },
  { id: '10', name: 'Helen Davis', age: 38, gender: 'female', location: 'Atlanta', injury: 'Whiplash', painLevel: 8 },
];